module.exports = __webpack_public_path__ + "img/bg-colorful.93652b5.jpg";